import { FiltroGuia } from "./filtroguia";
import { PagoRealizadoModel, pagoRealizadoInicial } from "./pagorealizado";

export interface EntregaOcurreModel {
    /**Guias seleccionadas */
    Folios: string[];
    filtro: Partial<FiltroGuia>;
    PagoRealizado: PagoRealizadoModel;
    IdFirmaRemota: string;
    /**Id del contacto que recibio la guia */
    IdContactoCliente?: number ;
    tab: number;
}

export const ocurreModelInicial: EntregaOcurreModel = {
    Folios: [],
    filtro: {},
    PagoRealizado: pagoRealizadoInicial,
    IdFirmaRemota: "",
    tab: 0
}


// WEBPACK FOOTER //
// ./app/models/ocurre.ts